import React from 'react'

import DealCard from '~/components/deal-card'

import { dummyData } from './dummy-data'

const NUMBER_OF_SKELETON_DEALS = 10

const SkeletonDealCard = ({ amount = NUMBER_OF_SKELETON_DEALS }: { amount: number }) => {
  const skeletonDeals = []

  for (let i = 0; i < amount; i++) {
    skeletonDeals.push(<DealCard key={i} {...dummyData(i + 1)} isSkeleton />)
  }

  return <>{skeletonDeals}</>
}

export default SkeletonDealCard
